// Generated using https://github.com/workivate/AnalyticsGen
// Last update: 21/02/2025
// DO NOT EDIT

/* eslint-disable */
import AnalyticsSingletonFactory, {
  Options,
} from '../../../common/analytics-engine';

const paramValueLength = 100;

export const AnalyticsEventsFactory = (options: Options) => {
  const Analytics = AnalyticsSingletonFactory(options);

  return {
    Dashboard: {
      WeeklyWellbeingDigest: {
        Article: {
          /** Everytime a user clicks on an Article within the 'Weekly Wellbeing Digest' an event should be sent with the name of the article as the item_name
category as the item_type and the position as the item_position */
          clicked: (
            itemId: string,

            itemName: string,

            itemType: string,

            itemPosition: number,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'WeeklyWellbeingDigest_Article',
              action: 'Clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
              item_type: itemType.substring(0, paramValueLength),
              item_position: itemPosition,
            }),
        },
      },

      Eap: {
        Modalities: {
          GetSupport: {
            /** Every time a user OnClick a modality with an external link

Include the related type of modality  (Chat, online schedualing)âOnline schedulingâ =Feature keys - Online scheduling, CareNow, Support and resources) */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_Modalities_GetSupport',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },
      },

      CareNow: {
        ViewProgramme: {
          /** Everytime a user clicks on 'view programme' within a CareNow card an event should be sent */
          clicked: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'CareNow_ViewProgramme',
              action: 'Clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },

        Heading: {
          /** Everytime a user clicks on 'Programmes' heading within a CareNow card, an event should be sent */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'CareNow_Heading',
              action: 'Clicked',
            }),
        },
      },

      Challenge: {
        ViewChallenge: {
          /** Everytime a user clicks on 'view challenge' within a Challenges card an event should be sent */
          clicked: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'Challenge_ViewChallenge',
              action: 'Clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },

        Heading: {
          /** Everytime a user clicks on 'Challenges' heading within a Challenges card, an event should be sent */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'Challenge_Heading',
              action: 'Clicked',
            }),
        },
      },

      Assessments: {
        ViewAssessment: {
          /** Everytime a user clicks on 'view assessment' within an Assessments card an event should be sent */
          clicked: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'Assessments_ViewAssessment',
              action: 'Clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },

        Heading: {
          /** Everytime a user clicks on 'Assessments' heading within an Assessments card, an event should be sent */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'Assessments_Heading',
              action: 'Clicked',
            }),
        },
      },

      Search: {
        Result: {
          /** When user clicks on a search result item an event should be sent with the article title (en_gb) and article ID */
          clicked: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'Search_Result',
              action: 'Clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),

          /** When user clicks on 'Copy link to share' in the search results, an event should be sent with the article title (en_gb) and article ID */
          copied: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'Search_Result',
              action: 'Copied',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },
      },

      OpenLifeWorks: {
        OpenLifeWorksButton: {
          /** When user clicks on 'Open LifeWorks' an event should be sent. */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'OpenLifeWorks_OpenLifeWorksButton',
              action: 'Clicked',
            }),
        },
      },

      PrivacyAndConfidentiality: {
        Link: {
          /** When a user clicks on 'Learn More' within Privacy & Confidentiality , an event should be sent with the position of the Learn More link (i.e., 1 - top of the page or 2 - bottom of the page) */
          clicked: (
            itemId: string,

            itemName: string,

            itemType: string,

            itemPosition: number,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'PrivacyAndConfidentiality_Link',
              action: 'Clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
              item_type: itemType.substring(0, paramValueLength),
              item_position: itemPosition,
            }),
        },
      },

      Recognition: {
        GiveRecognition: {
          /** When a user clicks on 'Give Recognition' within the Recognition popup (task module), an event should be sent. */
          recognised: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'Recognition_GiveRecognition',
              action: 'Recognised',
            }),
        },
      },
    },
  };
};
